import React from "react";
import * as Feather from "react-feather";
import { Link } from "react-router-dom";

const TopNavBar = () => {
  const authUser = JSON.parse(localStorage.getItem("VVRHCS"));
  // console.log(authUser);
  
  return (
    <nav className="top-navbar navbar navbar-expand navbar-light fixed-top">
      <i className="fas fa-user" style={{ color: "#10296C" }}></i>

      <span
        style={{
          fontFamily: "Arial",
          fontWeight: "bold",
          fontSize: "20px",
          color: "#10296C",
          marginLeft: "10px",
          textTransform: "capitalize",
        }}
      >
       {authUser.username}
      </span>

      <ul className="navbar-nav ml-auto ">
        <li className="nav-item">
          <Link to="/logout" className="nav-link" role="button">
            <i className="fas fa-sign-out-alt" style={{ color: "#10296C" }}></i>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className="nav-link"
            data-widget="pushmenu"
            to="#"
            role="button"
          >
            <i className="fas fa-bars" style={{ color: "#10296C" }}></i>
          </Link>
        </li>
        <li className="nav-item">
          <a
            className="nav-link"
            data-widget="fullscreen"
            href="#"
            role="button"
          >
            <i
              className="fas fa-expand-arrows-alt"
              style={{ color: "#10296C" }}
            ></i>
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default TopNavBar;
